import api from './api';

export interface SetorPostoTrabalho {
  id?: number;
  razao_social_cliente: string;
  cnpj_cliente: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
}

export interface Setor {
  id: number;
  nome: string;
  descricao?: string;
  is_prestacao_servico?: boolean;
  fotos?: Array<{ id?: string; url: string; nome: string; dataUrl?: string }>;
  postos?: SetorPostoTrabalho[];
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateSetorDto {
  nome: string;
  descricao?: string;
  empresa_id?: number;
  is_prestacao_servico?: boolean;
  fotos?: Array<{ id?: string; url: string; nome: string; dataUrl?: string }>;
  posto?: {
    razao_social_cliente: string;
    cnpj_cliente: string;
    cep?: string;
    logradouro?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    uf?: string;
  };
}

export interface ListSetoresParams {
  page?: number;
  limit?: number;
  search?: string;
  has_cargos?: boolean;
  empresa_id?: number;
}

export const setoresService = {
  async findAll(paramsOrLimit?: number | ListSetoresParams): Promise<PaginatedResponse<Setor>> {
    const params = typeof paramsOrLimit === 'number'
      ? { limit: paramsOrLimit }
      : paramsOrLimit || {};
    const response = await api.get<PaginatedResponse<Setor>>('/setores', { params });
    return response.data;
  },

  async create(data: CreateSetorDto): Promise<Setor> {
    const response = await api.post<Setor>('/setores', data);
    return response.data;
  },
};
